import React from "react";
import { useSelector } from "react-redux";

const DashboardMeasures = () => {
  const totalMeasuredCostsYear1 = useSelector(
    (state) => state.TotalMeasuredCostsYear.year1
  );
  const totalMeasuredCostsYear2 = useSelector(
    (state) => state.TotalMeasuredCostsYear.year2
  );
  const totalMeasuredCostsYear3 = useSelector(
    (state) => state.TotalMeasuredCostsYear.year3
  );
  const totalMeasuredHoursYear1 = useSelector(
    (state) => state.TotalMeasuredHoursYear.year1
  );
  const totalMeasuredHoursYear2 = useSelector(
    (state) => state.TotalMeasuredHoursYear.year2
  );
  const totalMeasuredHoursYear3 = useSelector(
    (state) => state.TotalMeasuredHoursYear.year3
  );
  const netProfitPerMonthYear1 = useSelector(
    (state) => state.salaryCalculationYear1.netProfitPerMonth
  );
  const netProfitPerMonthYear2 = useSelector(
    (state) => state.salaryCalculationYear2.netProfitPerMonth
  );
  const netProfitPerMonthYear3 = useSelector(
    (state) => state.salaryCalculationYear3.netProfitPerMonth
  );

  function addSumTotalHours() {
    let total =
      totalMeasuredHoursYear1 +
      totalMeasuredHoursYear2 +
      totalMeasuredHoursYear3;
    if (total) {
      //hide decimal if none
      // if (total % 1 === 0) {
      //   return (total = parseInt(total, 10));
      // } else {
      //   return (total = parseFloat(total, 10).toFixed(1));
      // }
      return total;
    } else {
      return 0;
    }
  }
  function addSumTotalCosts() {
    let total =
      totalMeasuredCostsYear1 +
      totalMeasuredCostsYear2 +
      totalMeasuredCostsYear3;
    if (total) {
      //hide decimal if none
      // if (total % 1 === 0) {
      //   return (total = parseInt(total, 10));
      // } else {
      //   return (total = parseFloat(total, 10).toFixed(1));
      // }
      return total;
    } else {
      return 0;
    }
  }
  // function hideDecimalIfNone(value) {
  //   var amount = value;
  //   if (amount % 1 === 0) {
  //     return (amount = parseInt(amount, 10));
  //   } else {
  //     return (amount = parseFloat(amount, 10).toFixed(1));
  //   }
  // }

  return (
    <div className="container-dashboard-mobile">
      <div className="container-inner-dashboard-mobile">
        <div className="container-inner-flex-direction">
          <div className="container-inner-flex-direction">
            <label>Åtgärdstimmar År 1</label>

            <output className="output-mobile">
              {Math.round(
                totalMeasuredHoursYear1 > 0 ? totalMeasuredHoursYear1 : 0
              )}
            </output>
          </div>
          <div className="container-inner-flex-direction">
            <label>Åtgärdstimmar År 2</label>

            <output className="output-mobile">
              {Math.round(
                totalMeasuredHoursYear2 > 0 ? totalMeasuredHoursYear2 : 0
              )}
            </output>
          </div>
          <div className="container-inner-flex-direction">
            <label>Åtgärdstimmar År 3</label>

            <output className="output-mobile">
              {Math.round(
                totalMeasuredHoursYear3 > 0 ? totalMeasuredHoursYear3 : 0
              )}
            </output>
          </div>
          <div className="container-inner-flex-direction">
            <label>Samtliga Åtgärdstimmar</label>

            <output className="output-mobile">{addSumTotalHours()}</output>
          </div>
        </div>
        <div className="container-inner-flex-direction">
          <div className="container-inner-flex-direction">
            <label>Åtgärdskostnader År 1</label>

            <output className="output-mobile">
              {Math.round(
                totalMeasuredCostsYear1 > 0 ? totalMeasuredCostsYear1 : 0
              )}
            </output>
          </div>
          <div className="container-inner-flex-direction">
            <label>Åtgärdskostnader År 2</label>

            <output className="output-mobile">
              {Math.round(
                totalMeasuredCostsYear2 > 0 ? totalMeasuredCostsYear2 : 0
              )}
            </output>
          </div>
          <div className="container-inner-flex-direction">
            <label>Åtgärdskostnader År 3</label>

            <output className="output-mobile">
              {Math.round(
                totalMeasuredCostsYear3 > 0 ? totalMeasuredCostsYear3 : 0
              )}
            </output>
          </div>
          <div className="container-inner-flex-direction">
            <label>Samtliga Åtgärdskostnader</label>

            <output className="output-mobile">{addSumTotalCosts()}</output>
          </div>
        </div>
      </div>
      <div className="container-inner-flex-direction-row">
        <div className="container-inner-flex-direction">
          <label>Månadslön År 1</label>

          <output className="output-mobile">
            {Math.round(
              netProfitPerMonthYear1 > 0 ? netProfitPerMonthYear1 : 0
            )}
          </output>
        </div>
        <div className="container-inner-flex-direction">
          <label> Månadslön År 2</label>

          <output className="output-mobile">
            {Math.round(
              netProfitPerMonthYear2 > 0 ? netProfitPerMonthYear2 : 0
            )}
          </output>
        </div>
        <div className="container-inner-flex-direction">
          <label>Månadslön År 3</label>

          <output className="output-mobile">
            {Math.round(
              netProfitPerMonthYear3 > 0 ? netProfitPerMonthYear3 : 0
            )}
          </output>
        </div>
      </div>
    </div>
  );
};
export default DashboardMeasures;
